import { createRouter, createWebHistory } from "vue-router";
// import main from '../../views/Frontpage/main/index.vue'// 前台页面
// 路由拆分管理
import { FrontpageRouter } from "./routes/Frontpage"; // 前台
import { mappingPageRouter } from "./routes/mapping"; // 知识图谱
import { BackstageRouter } from "./routes/Backstage"; // 后台
import { compareRouter } from "./routes/compare"; // 对比分析
// 例：路由结构
const public_routes = [
  {
    path: "/loginWrapt",
    name: "loginWrapt",
    component: () => import("../views/login/index.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/login/login/index.vue"),
      },
      {
        path: "/qrlogin",
        name: "qrlogin",
        component: () => import("../views/login/qrLogin/index.vue"),
      },
    ],
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register/index.vue"),
    children: [
      {
        path: "/register",
        name: "register1",
        component: () => import("../views/register/register/index.vue"),
      },
      {
        path: "/qrRegister",
        name: "qrRegister",
        component: () => import("../views/register/qrRegister/index.vue"),
      },
    ],
  },
  {
    path: "/Wenxiang_H5Login",
    name: "Wenxiang_H5Login",
    component: () => import("../views/App/login"),
    meta: {
      skip_login: true, // 免登录 设置为true
    },
  },
  {
    path: "/activation",
    name: "activation",
    component: () => import("../views/Frontpage/activation/index.vue"),
    children: [],
  },
  {
    path: "/lengthen",
    name: "lengthen",
    component: () => import("../views/Frontpage/activation/lengthen.vue"),
    children: [],
  },
  {
    path: "/awaitPage",
    name: "awaitPage",
    component: () => import("../views/Frontpage/awaitPage/index.vue"),
    children: [],
  },
  {
    path: "/Wenxiang_H5Register",
    name: "Wenxiang_H5Register",
    component: () => import("../views/App/register"),
    meta: {
      skip_login: true, // 免登录 设置为true
    },
  },
  {
    path: "/liveSharing",
    name: "liveSharing",
    component: () => import("../views/App/LiveSharing/index.vue"),
    meta: {
      skip_login: true, // 免登录 设置为true
    },
  },
  // 个人信息
  {
    path: "/wenxiang/userInfo",
    menuId: "userInfo",
    name: "userInfo",
    component: () => import("@/views/Frontpage/userInfo"),
    meta: {
      affiliation_Head: "userInfo", // 归属级 (头部的)
      affiliation_Left: "userInfo", // 归属级 (左侧的)
    },
  },
  {
    // 视频剪辑
    path: "/wenxiang/videocut",
    name: "videocut",
    component: () => import("@/views/Frontpage/videoCut/index.vue"),
    meta: {
      transparency_Head: false,
      affiliation_Head: "", // 归属级 (头部的)
      affiliation_Left: "", // 归属级 (左侧的)
    },
  },
  {
    // 视频剪辑
    path: "/wenxiang/audiocut",
    name: "audiocut",
    component: () => import("@/views/Frontpage/audioCut/index.vue"),
    meta: {
      transparency_Head: false,
      affiliation_Head: "", // 归属级 (头部的)
      affiliation_Left: "", // 归属级 (左侧的)
    },
  },
  //单点登录
  {
    path: "/SSO",
    name: "SSO",
    component: () => import("@/views/wx-SSO")
  },
  {
    // 手机端缺省页
    path: "/appDefaultPage",
    name: "DefaultPage",
    component: () => import("../views/App/DefaultPage/index.vue"),
    meta: {
      skip_login: true, // 免登录 设置为true
    },
  },
];
// 整合路由
const routes = [...public_routes, ...FrontpageRouter, ...BackstageRouter,...mappingPageRouter,...compareRouter];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
